import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Package, BookOpen, ShoppingCart, BarChart3 } from 'lucide-react';

const AdminDashboard = ({ stats }) => {
  const { t } = useTranslation();
  
  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-2xl font-bold mb-8">{t('admin.dashboard')}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">{t('admin.totalProducts')}</p>
                <p className="text-3xl font-bold">{stats?.products_count || 0}</p>
              </div>
              <Package className="w-10 h-10 text-green-600" />
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">{t('admin.totalRecipes')}</p>
                <p className="text-3xl font-bold">{stats?.recipes_count || 0}</p>
              </div>
              <BookOpen className="w-10 h-10 text-blue-600" />
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">{t('admin.totalOrders')}</p>
                <p className="text-3xl font-bold">{stats?.orders_count || 0}</p>
              </div>
              <ShoppingCart className="w-10 h-10 text-purple-600" />
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">{t('admin.totalRevenue')}</p>
                <p className="text-3xl font-bold">¥{(stats?.total_revenue || 0).toFixed(2)}</p>
              </div>
              <BarChart3 className="w-10 h-10 text-orange-600" />
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>{t('admin.recentOrders')}</CardTitle>
        </CardHeader>
        <CardContent>
          {stats?.recent_orders?.length > 0 ? (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>{t('admin.orderNumber')}</TableHead>
                  <TableHead>{t('admin.amount')}</TableHead>
                  <TableHead>{t('admin.status')}</TableHead>
                  <TableHead>{t('admin.time')}</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {stats.recent_orders.map((order) => (
                  <TableRow key={order.id}>
                    <TableCell className="font-mono text-sm">{order.order_number}</TableCell>
                    <TableCell>¥{(order.total_amount ?? 0).toFixed(2)}</TableCell>
                    <TableCell>
                      <Badge variant="outline">{order.status}</Badge>
                    </TableCell>
                    <TableCell className="text-gray-500">
                      {new Date(order.created_at).toLocaleString('zh-CN')}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <p className="text-gray-500 text-center py-8">{t('admin.noOrders')}</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminDashboard;
